import React, { FC, useEffect } from 'react';
import { Asset, BoltIcon, WarningIcon } from '@clearcover/atlas';
import { useAppContext } from 'QuoteApp/services/providers';
import styles from './styles.module.css';

const RewardBolt: FC<{ status: 'active' | 'inactive' }> = ({ status }) => (
  <Asset
    icon={BoltIcon}
    height={20}
    width={20}
    description="Reward"
    className={
      status === 'active' ? styles.bulletIconActive : styles.bulletIconInactive
    }
  />
);

export const RewardPointsEstimate: FC = () => {
  const {
    details,
    refreshDetails,
    estimatePointsResponse,
    submitEstimatePoints,
    isEstimatePointsLoading,
    rewardsPointsError,
  } = useAppContext();

  useEffect(() => {
    if (!details) {
      refreshDetails();
      return;
    }

    if (!isEstimatePointsLoading) {
      submitEstimatePoints(details);
    }
    // We're only concerned about estimating points if details changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [details]);

  return (
    <div className={styles.container}>
      <div className={styles.top}>Clearcover Rewards</div>
      {rewardsPointsError && (
        <button onClick={refreshDetails} className={styles.retryContainer}>
          <Asset
            icon={WarningIcon}
            height={20}
            width={20}
            description="Warning icon"
            className={styles.warningIcon}
          />
          Recalculate
        </button>
      )}
      {!rewardsPointsError && (
        <div className={styles.bottom}>
          {estimatePointsResponse?.processedRules.map((_, i) => {
            return <RewardBolt key={`processed-rule-${i}`} status="active" />;
          })}
          {estimatePointsResponse?.failedRules.map((_, i) => {
            return <RewardBolt key={`failed-rule-${i}`} status="inactive" />;
          })}
        </div>
      )}
    </div>
  );
};
